module.exports = require('./TokenSimulationBehavior');